<template>
  <b-sidebar
    :id="isMdOrHigher? 'desktop-sidebar' : 'mobile-sidebar'"
    bg-variant="dark"
    text-variant="light"
    width="260px"
    shadow
    :visible="isMdOrHigher"
    no-header
    no-close-on-esc
  >
    <!-- <template v-slot:default="{ hide }"> -->
    <template v-slot:default>
      <h4 class="text-center py-3 mb-3" style="border-bottom:solid 1px #CCC">
        {{ title }}
        <!-- <b-icon-x class="float-right mr-2 d-sm-block d-md-none" @click="hide" /> -->
      </h4>
      <b-col
        cols="12"
        class="pl-5 mb-2"
        style="border-bottom: solid 1px #666"
        v-for="(tab, index) in tabs"
        :key="index"
      >
        <b-button
          variant="link"
          class="cp-tab"
          :to="{ name: tab.name, query: tab.query, params: tab.params }"
          :style="{
            color: $route.name === tab.name ? '#FFF' : '#AAA',
            'text-decoration': 'none',
          }"
        >
          <p>
            <b-icon :icon="tab.icon" class="mr-3" />
            <span class="text-uppercase">{{ tab.title }}</span>
          </p>
        </b-button>
      </b-col>
    </template>
    <template v-slot:footer>
      <b-button squared variant="primary" block @click="logout">
        <b-icon-arrow-left-short class="mr-3" />Logout
      </b-button>
    </template>
  </b-sidebar>
</template>

<style>
.cp-tab:active {
  border: none !important;
}
.cp-tab:hover > p {
  color: #fff;
}
</style>

<script>
export default {
  name: "Sidebar",
  props:{
    title: {
      default: () => ""
    },
    tabs:{
      required: true
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('auth/logout');
      this.$router.push({name: 'home'})
    }
  }
}
</script>